import Language from "../models/Language";

export default class LanguageMapper {
    public map(data: any): Language {
        const language: Language = new Language();

        if (data) {
            language.name = data.Name;
            language.code = data.Code;
        }

        return language;
    }
}